import PropTypes from 'prop-types';
import React from 'react';
import { GENDER } from '~graphql-types';
import { GenderFemale, GenderMale, GenderMix } from '~svg-components';

const GenderIcon = React.forwardRef((props, ref) => {
  const { gender, ...otherProps } = props;

  if (gender === GENDER.MALE) {
    return <GenderMale color="blue" {...otherProps} ref={ref} />;
  }
  if (gender === GENDER.FEMALE) {
    return <GenderFemale color="rose" {...otherProps} ref={ref} />;
  }
  if (gender === GENDER.NEUTRAL) {
    return <GenderMix color="violet" {...otherProps} ref={ref} />;
  }
  return null;
});

GenderIcon.propTypes = {
  gender: PropTypes.string,
};
GenderIcon.defaultProps = {
  gender: undefined,
};

export default GenderIcon;
